// 此文件不要动
export const nameComponentObj = {
  "recycleBinManage": {
    name: "recycleBinManage",
    label: "回收站",
    permissionIdentification: "recycleBin:list", // 权限标识
    component: () => import(/* webpackChunkName: "recycleBinModule" */"@/views/recycle-bin.vue")
  }
}

// 没有按钮权限标识数据 也要暴露一个对象出去
export const btnObj = {
  recycleBinRestore: {
    label: "回收站/还原",
    value: "recycleBin:restore"
  },
  recycleBinDelete: {
    label: "回收站/彻底删除",
    value: "recycleBin:delete"
  }
}